import type { PageGuidanceId } from "@/content/guidance/pageGuidance";

const STORAGE_PREFIX = "fomo-fi:page-guidance";

const WEB_ROUTES: ReadonlyArray<[string, PageGuidanceId]> = [
  ["/dashboard", "dashboard"],
  ["/transactions", "transactions"],
  ["/rules", "transactions"],
  // RD-07: Rules' address with the redesign switch on; before /settings, first match wins.
  ["/settings/rules", "transactions"],
  ["/budgets", "budgets"],
  ["/calendar", "calendar"],
  ["/goals", "goals"],
  ["/forecast", "forecast"],
  ["/insights", "insights"],
  ["/financial-analysis", "financialAnalysis"],
  ["/debt", "debt"],
  ["/payment", "payment"],
  ["/recurring", "recurring"],
  ["/settings", "settings"],
  ["/banks", "banks"],
];

export function pageGuidanceIdForPath(pathname: string): PageGuidanceId | null {
  if (pathname === "/payment/success") return null;
  return (
    WEB_ROUTES.find(([route]) => pathname === route || pathname.startsWith(`${route}/`))?.[1] ??
    null
  );
}

function storageKey(userId: string, pageId: PageGuidanceId): string {
  return `${STORAGE_PREFIX}:${userId}:${pageId}`;
}

export function readPageGuidance(userId: string, pageId: PageGuidanceId): boolean {
  try {
    return localStorage.getItem(storageKey(userId, pageId)) === "true";
  } catch {
    return false;
  }
}

export function writePageGuidance(userId: string, pageId: PageGuidanceId, enabled: boolean): void {
  try {
    localStorage.setItem(storageKey(userId, pageId), String(enabled));
  } catch {
    // Guidance persistence is cosmetic; storage denial must not break the page.
  }
}
